import { useSuspenseQuery } from '@tanstack/react-query';

// Disable caching to avoid having cached image with charts that are still loading
export const useExportCanvas = (
  exportedElementId: string,
  cacheKey: string
) => {
  return useSuspenseQuery({
    queryKey: ['export-image', exportedElementId, cacheKey],
    gcTime: 0, // no caching
    queryFn: async () => {
      const doc = document.querySelector(
        `#${exportedElementId}`
      ) as HTMLCanvasElement;
      const html2canvas = (
        await import(
          /* webpackChunkName: "htmlToCanvas" */
          /* webpackMode: "lazy" */
          'html2canvas'
        )
      ).default;

      const imageCanvas = await html2canvas(doc, {
        scrollY: -window.scrollY,
      });
      const image = imageCanvas.toDataURL('image/png');
      return image;
    },
  });
};
